import { CURRENCY_NAME } from "@/constants/constants";
import { FirstSportGameId } from "@/enum/game";
import { pointFormatterOrigin } from "@/lib/pointUtils";
import { gameStore } from "@/stores/gameStore";
import { getUserPoint, userStore } from "@/stores/userStore";

export function useSendMsgToIframe() {
  const sendMsgToIframe = (jsonObj: object, source: Window | null = null) => {
    if (!source) {
      source = (
        document.getElementById("first-sport-iframe") as HTMLIFrameElement
      )?.contentWindow;
    }
    if (source) {
      source.postMessage(JSON.stringify(jsonObj), "*");
    } else {
      console.log("[sendMsgToIframe] source is null");
    }
  };
  const updateFirstSportData = () => {
    if (Number(gameStore.curGameId) == FirstSportGameId) {
      const point = getUserPoint();

      const pointFormat = pointFormatterOrigin(
        point,
        userStore.walletPointType,
      );
      sendMsgToIframe({
        cmd: "first_sport_data",
        param: {
          isNeedUpdate: true,
          balance: "" + pointFormat,
          currency: CURRENCY_NAME,
        },
      });
    }
  };
  return { sendMsgToIframe, updateFirstSportData };
}
